import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {KundeDTO} from '../../openapi/fakturierung-openapi';


export const kundeEntitiesAdapter: EntityAdapter<KundeDTO> = createEntityAdapter<KundeDTO>();
